import useTicketStatsQuery from '~/hooks/services/servicenow/queries/useTicketStatsQuery'

import { IoTicket } from 'react-icons/io5'
import { useNavigate } from 'react-router'

import { Tile, TileHeader } from '../Tile'

const OpenTicketsTile = () => {
  const navigate = useNavigate()
  const { data: ticketStats, isLoading } = useTicketStatsQuery()

  return (
    <Tile onMouseDown={() => navigate('/tickets?state=open')}>
      <TileHeader loading={isLoading}>
        <TileHeader.Title>{ticketStats?.open ?? 0}</TileHeader.Title>
        <TileHeader.Subtitle>Open Tickets</TileHeader.Subtitle>
        <TileHeader.Item>
          <IoTicket className="h-10 w-10 text-th-warning" />
        </TileHeader.Item>
      </TileHeader>
    </Tile>
  )
}

export default OpenTicketsTile
